<script>
	// Constants
	import { UserRatingColours } from '@/Constants/User.js';

	export let rating;
	export let className = '';
</script>

<div
	class="p-1 text-center rounded-md text-tiny {UserRatingColours[rating.id]?.bg ?? 'bg-gray-300'}
  {UserRatingColours[rating.id]?.text ?? 'text-dark'}
  {className}"
>
	{rating.name}
</div>
